import { SafeLogErrorOptions } from '../log-error';
import { BaseError } from './BaseError';

export class GracefullReconnectError extends BaseError {
    constructor(message: string, loggerFields: SafeLogErrorOptions) {
        super(message, loggerFields);

        Object.setPrototypeOf(this, GracefullReconnectError.prototype);
    }
}
